module.exports = __webpack_public_path__ + "img/video_game_type_article_button.27ab5ae7.jpg";